import React, { useState } from 'react';
import { InputGroup, FormControl, Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRotateRight, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

function GeneratedPasswordTextBox({ password, setPassword, generate }) {
  const [inputType, setInputType] = useState(true);

  return (
    <React.Fragment>
      <InputGroup>
        <InputGroup.Prepend>
          <Button
            tabIndex={-1}
            className="button-generate-password"
            onClick={generate}
            size="sm"
            variant="outline-secondary"
          >
            <FontAwesomeIcon icon={faArrowRotateRight} />
          </Button>
        </InputGroup.Prepend>
        <FormControl
          size="sm"
          type={inputType ? 'password' : 'text'}
          placeholder="New password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          isInvalid={password.length <= 0}
        />
       
        <InputGroup.Append>
          <Button
            tabIndex={-1}
            className="button-show-password"
            onClick={() => setInputType(!inputType)}
            size="sm"
            variant="outline-secondary"
          >
            {inputType ? <FontAwesomeIcon icon={faEye} /> : <FontAwesomeIcon icon={faEyeSlash} />}
          </Button>
        </InputGroup.Append>
      </InputGroup>
    </React.Fragment>
  );
}

export default GeneratedPasswordTextBox;
